import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe, loginAdmin } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rit_token");
    if (!token) {
      setLoading(false);
      return;
    }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("rit_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await loginAdmin(email, password);
    localStorage.setItem("rit_token", res.access_token);
    setUser({ email: res.email });
    return res;
  };

  const logout = () => {
    localStorage.removeItem("rit_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth outside provider");
  return ctx;
};
